<notify>
  <div class="ntfy-register-result">
    <div class="loading" if="{ state.registerResult === 0 }">
      メッセージ受信登録中。。。
    </div>
    <div class="success" if="{ state.registerResult === 1 }">
      メッセージ受信登録が完了しました。
    </div>
    <div class="failure" if="{ state.registerResult === 2 }">
      メッセージ受信登録に失敗しました。
    </div>
  </div>
  <script>
    export default {
      state: {
        registerResult: 0, // 0=loading, 1=success, 2=failure
      },

      onBeforeMount() {

      },

      async onMounted() {
        const res = await this.props.ntfyRegisterUrl(this.props.registerKey);
        this.state.registerResult = res;
        this.update();
      }
    };
  </script>
  <style>
    .ntfy-register-result {
      justify-items: center;
    }
  </style>
</notify>